// extracted by mini-css-extract-plugin
export default {"card":"n4-z"};